import { createAsyncThunk } from '@reduxjs/toolkit'
import questionnaireAnswersService from 'services/questionnaire-answers'

export const updateQuestionnaireAnswers = createAsyncThunk(
	'questionnaire-answers/update',
	questionnaireAnswersService.updateQuestionnaireAnswers
)
